import BaseUpdateRequest from "../Shared/BaseUpdateRequest";

export default class SendJobWorkerOfferToWorkerRequest extends BaseUpdateRequest {
    jobWorkerOfferId: string;
}